<!-- autocomplete diagnostic master -->

<label *ngIf="label"
       [attr.for]="inputId">
  {{ label }}
  <span *ngIf="required" class="text-danger">*</span>
</label>

<input [id]="inputId" [formControl]="myFormControl" [placeholder]="placeholder" maxlength="11"
    (keydown)="StaticHandlers.handleKeyDown($event, '0-9A-Z')" 
    (paste)="StaticHandlers.handlePaste($event, '0-9A-Z')" 
    matInput type="text"
    [matAutocomplete]="auto"
    (input)="onChangefilter()"
    (blur)="clearIfNotSelected()"
    [ngClass]="{
        'border-danger': myFormControl.invalid 
                    && (myFormControl.touched || myFormControl.dirty)
                    && required
      }"/>
    
<mat-autocomplete #auto="matAutocomplete" 
    (optionSelected)="onItemSelected($event)">
    <mat-option *ngFor="let item of resultList" 
        [value]="item"> {{item}} </mat-option>
</mat-autocomplete>

<mat-error *ngIf="myFormControl.invalid && myFormControl.touched && errorStr" class="text-danger">
    {{ (notFoundCoincidences && errorNotFoundStr) ? errorNotFoundStr : errorStr }}
</mat-error>
